var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ElasticSearch = (function (ElasticSearch) {

        ElasticSearch.Messages = (function (Messages) {

            Messages.GetElasticSuggestions = function (searchTerm, size, since, textTransform, fuzziness, source) {
                var data = {
                    queryTerm: searchTerm,
                    size: size,
                    since: since,
                    case: textTransform,
                    fuzziness: fuzziness,
                    source: source
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetElasticSuggestions", data);
            };
            Messages.GetElasticSuggestions.className = "Vendd.ElasticSearch.Messages.GetElasticSuggestions";

            Messages.GetElasticSuggestionsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetElasticSuggestionsSuccess", data);
            };
            Messages.GetElasticSuggestionsSuccess.className = "Vendd.ElasticSearch.Messages.GetElasticSuggestionsSuccess";

            Messages.GetElasticSuggestionsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetElasticSuggestionsFailed", response);
            };
            Messages.GetElasticSuggestionsFailed.className = "Vendd.ElasticSearch.Messages.GetElasticSuggestionsFailed";

            Messages.GetFiltersElasticResults = function (searchTerm, filters, baseuri) {
                var data = {
                    searchTerm: searchTerm,
                    filters: filters,
                    baseuri: baseuri
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetFiltersElasticResults", data);
            };
            Messages.GetFiltersElasticResults.className = "Vendd.ElasticSearch.Messages.GetFiltersElasticResults";

            Messages.GetFiltersElasticResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetFiltersElasticResultsSuccess", data);
            };
            Messages.GetFiltersElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetFiltersElasticResultsSuccess";

            Messages.GetFiltersElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetFiltersElasticResultsFailed", response);
            };
            Messages.GetFiltersElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetFiltersElasticResultsFailed";


            Messages.GetCategoryElasticResults = function (searchTerm, pageFrom, pageSize) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResults", data);
            };
            Messages.GetCategoryElasticResults.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResults";

            Messages.GetCategoryElasticResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess", data);
            };
            Messages.GetCategoryElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess";

            Messages.GetCategoryElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed", response);
            };
            Messages.GetCategoryElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed";

            Messages.GetProductElasticResults = function (searchTerm, pageFrom, pageSize, query, path, fields, geo_window, filters) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize,
                    query: query,
                    path: path,
                    fields: fields,
                    geo_window: geo_window,
                    filters: filters
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResults", data);
            };
            Messages.GetProductElasticResults.className = "Vendd.ElasticSearch.Messages.GetProductElasticResults";

            Messages.GetProductElasticResultsSuccess = function (model, sender) {
                var data = {
                    model: model,
                    sender: sender
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess", data);
            };
            Messages.GetProductElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess";

            Messages.GetProductElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed", response);
            };
            Messages.GetProductElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed";

            Messages.GetArticleElasticResults = function (searchTerm, pageFrom, pageSize) {
                var data = {
                    searchTerm: searchTerm,
                    pageFrom: pageFrom,
                    pageSize: pageSize
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetArticleElasticResults", data);
            };
            Messages.GetArticleElasticResults.className = "Vendd.ElasticSearch.Messages.GetArticleElasticResults";

            Messages.GetArticleElasticResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess", data);
            };
            Messages.GetArticleElasticResultsSuccess.className = "Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess";

            Messages.GetArticleElasticResultsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ElasticSearch.Messages.GetArticleElasticResultsFailed", response);
            };
            Messages.GetArticleElasticResultsFailed.className = "Vendd.ElasticSearch.Messages.GetArticleElasticResultsFailed";

            return Messages;

        })(ElasticSearch.Messages || {});

        return ElasticSearch;

    })(Vendd.ElasticSearch || {});

    return Vendd;

})(Vendd || {});